(function(){
var S={};try{var sj=document.querySelector('[data-wlt]');if(sj)S=JSON.parse(sj.textContent)||{};}catch(x){S={};}
var KEY='hw_wl';
var AR=['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
function ar(n){var s=String(n),o='';for(var i=0;i<s.length;i++){o+=(s[i]>='0'&&s[i]<='9')?AR[+s[i]]:s[i];}return o;}
function money(c){return ar(Math.round(c/100))+' ج.م';}
function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function load(){try{var a=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a:[];}catch(e){return [];}}
function save(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
function has(a,id){for(var i=0;i<a.length;i++){if(String(a[i].id)===String(id))return i;}return -1;}
var toastEl=document.querySelector('[data-toast]'),tt;
function toast(m){if(!toastEl||!m)return;toastEl.textContent=m;toastEl.setAttribute('data-show','true');clearTimeout(tt);tt=setTimeout(function(){toastEl.setAttribute('data-show','false');},2200);}
var drawer=null,lastF=null;
function ensure(){
if(drawer)return drawer;
drawer=document.createElement('div');
drawer.className='drawer wld';
drawer.setAttribute('data-wld','');
drawer.setAttribute('data-open','false');
drawer.innerHTML='<div class="dim" data-wl-close></div><aside class="panel" role="dialog" aria-modal="true" aria-label="'+esc(S.wl)+'"><div class="ph"><h3>'+esc(S.wl)+' <small data-wl-h></small></h3><button type="button" class="ico" data-wl-close aria-label="'+esc(S.close)+'"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="pb" data-wl-body></div><div class="pf"><a class="btn wide" href="/collections/all">'+esc(S.shop)+'</a></div></aside>';
document.body.appendChild(drawer);
return drawer;
}
function renderList(){
if(!drawer)return;
var a=load(),body=drawer.querySelector('[data-wl-body]'),hd=drawer.querySelector('[data-wl-h]');
hd.textContent=a.length?ar(a.length):'';
if(!a.length){body.innerHTML='<div class="empty"><b>'+esc(S.empty)+'</b>'+esc(S.emptySub)+'</div>';return;}
var out='';
for(var i=0;i<a.length;i++){
var it=a[i],img=it.img?'<img src="'+esc(it.img)+'" alt="" loading="lazy">':'<div class="sw"></div>';
out+='<div class="li"><a class="lim" href="'+esc(it.u)+'">'+img+'</a><div class="lin"><a class="lit" href="'+esc(it.u)+'">'+esc(it.t)+'</a><div class="liv wlpr"><b>'+money(it.p)+'</b>'+(it.c>it.p?'<s>'+money(it.c)+'</s>':'')+'</div><div class="wla"><a class="wlgo" href="'+esc(it.u)+'">'+esc(S.see)+'</a><button type="button" class="rm" data-wl-rm="'+esc(it.id)+'">'+esc(S.remove)+'</button></div></div></div>';
}
body.innerHTML=out;
}
function sync(){
var a=load(),btns=document.querySelectorAll('[data-wl]');
for(var i=0;i<btns.length;i++){var on=has(a,btns[i].getAttribute('data-wl'))>=0;btns[i].classList.toggle('on',on);btns[i].setAttribute('aria-pressed',on?'true':'false');}
var cs=document.querySelectorAll('[data-wl-count]');
for(var j=0;j<cs.length;j++){cs[j].textContent=ar(a.length);cs[j].hidden=!a.length;}
if(drawer&&drawer.getAttribute('data-open')==='true')renderList();
}
function toggle(b){
var a=load(),id=b.getAttribute('data-wl'),i=has(a,id);
if(i>=0){a.splice(i,1);save(a);sync();toast(S.removed);return;}
a.unshift({id:id,t:b.getAttribute('data-t')||'',u:b.getAttribute('data-u')||'',img:b.getAttribute('data-img')||'',p:parseInt(b.getAttribute('data-p')||'0',10)||0,c:parseInt(b.getAttribute('data-c')||'0',10)||0});
if(a.length>60)a.length=60;
save(a);sync();
b.classList.remove('pop');void b.offsetWidth;b.classList.add('pop');
setTimeout(function(){b.classList.remove('pop');},650);
toast(S.added);
}
function openD(){
ensure();renderList();lastF=document.activeElement;
document.body.classList.add('locked');
requestAnimationFrame(function(){drawer.setAttribute('data-open','true');});
if(window.hwOverlay)hwOverlay.open('wl',function(){closeD(true);});
var x=drawer.querySelector('.ico');if(x)setTimeout(function(){x.focus();},80);
}
function closeD(fromPop){
if(!drawer||drawer.getAttribute('data-open')!=='true')return;
drawer.setAttribute('data-open','false');
document.body.classList.remove('locked');
if(fromPop!==true&&window.hwOverlay)hwOverlay.close('wl');
if(lastF&&lastF.focus)lastF.focus();
}
var shb=document.querySelector('[data-share]');
var tip=shb?shb.querySelector('[data-shtip]'):null;
var pop=null;
function hideTip(){if(tip)tip.classList.remove('show');if(shb)shb.classList.remove('hint');}
function shareUrl(){var u=location.origin+location.pathname;return u+'?utm_source=share&utm_medium=friend';}
var ICW='<svg viewBox="0 0 24 24"><path d="M4 20l1.5-4A8 8 0 1112 20a8 8 0 01-4-1z"/><path d="M9 10c0 3 2 5 5 5"/></svg>';
var ICF='<svg viewBox="0 0 24 24"><path d="M14 8h2V5h-2a4 4 0 00-4 4v2H8v3h2v6h3v-6h2.5l.5-3h-3V9a1 1 0 011-1z"/></svg>';
var ICL='<svg viewBox="0 0 24 24"><path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1"/></svg>';
function openPop(text,url){
if(!pop){pop=document.createElement('div');pop.className='shpop';pop.setAttribute('role','menu');shb.parentNode.appendChild(pop);}
var wa='https://wa.me/?text='+encodeURIComponent(text+'\n'+url);
var fb='https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url);
pop.innerHTML='<b>'+esc(S.shareTitle)+'</b><a href="'+esc(wa)+'" target="_blank" rel="noopener" role="menuitem">'+ICW+esc(S.wa)+'</a><a href="'+esc(fb)+'" target="_blank" rel="noopener" role="menuitem">'+ICF+esc(S.fb)+'</a><button type="button" role="menuitem" data-copy="'+esc(url)+'">'+ICL+esc(S.copy)+'</button>';
pop.classList.add('open');
}
function closePop(){if(pop)pop.classList.remove('open');}
function copy(u){
var done=function(){toast(S.copied);};
if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(u).then(done,function(){legacy(u);done();});return;}
legacy(u);done();
}
function legacy(u){try{var ta=document.createElement('textarea');ta.value=u;ta.setAttribute('readonly','');ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);}catch(e){}}
function doShare(){
hideTip();
var t=shb.getAttribute('data-t')||document.title;
var text=String(S.shareText||'').replace('{t}',t);
var url=shareUrl();
if(navigator.share){navigator.share({title:t,text:text,url:url}).catch(function(){});return;}
if(pop&&pop.classList.contains('open')){closePop();return;}
openPop(text,url);
}
if(shb&&tip){
var seen=false;try{seen=sessionStorage.getItem('hw_sh')==='1';}catch(e){}
if(!seen){
setTimeout(function(){
if(pop&&pop.classList.contains('open'))return;
shb.classList.add('hint');tip.classList.add('show');
try{sessionStorage.setItem('hw_sh','1');}catch(e){}
setTimeout(hideTip,5500);
},2200);
}
}
document.addEventListener('click',function(e){
var t=e.target;if(!t||!t.closest)return;
var w=t.closest('[data-wl]');
if(w){e.preventDefault();toggle(w);return;}
if(t.closest('[data-wl-open]')){e.preventDefault();openD();return;}
if(t.closest('[data-wl-close]')){e.preventDefault();closeD();return;}
var rm=t.closest('[data-wl-rm]');
if(rm){var a=load(),i=has(a,rm.getAttribute('data-wl-rm'));if(i>=0){a.splice(i,1);save(a);}sync();return;}
if(t.closest('[data-share]')){e.preventDefault();doShare();return;}
var cp=t.closest('[data-copy]');
if(cp){copy(cp.getAttribute('data-copy'));closePop();return;}
if(pop&&pop.classList.contains('open')&&!t.closest('.shpop'))closePop();
if(tip&&tip.classList.contains('show'))hideTip();
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeD();closePop();hideTip();}});
window.addEventListener('storage',function(e){if(e.key===KEY)sync();});
sync();
})();
